import { useQuery } from '@tanstack/react-query';

import axios from 'axios';
import { ExtractFnReturnType, QueryConfig } from 'lib/react-query';

import { Satellite } from 'types';

export const getSatellite = async (
  satelliteId: number
): Promise<Satellite | undefined> => {
  if (satelliteId < 1) return;
  const { data } = await axios.get(`/api/satellites/${satelliteId}`);
  return data as Satellite;
};

type QueryFnType = typeof getSatellite;

type UseSatelliteOptions = {
  satelliteId: number;
  config?: QueryConfig<QueryFnType>;
};

export const useSatellite = ({ satelliteId, config }: UseSatelliteOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['satellites', satelliteId],
    queryFn: () => getSatellite(satelliteId),
  });
};
